<template>
  <div class="hua-box">
    <div class="box-head">
      <el-page-header @back="goBack" content=""></el-page-header>
      <span>预警类型名称：</span>
      <el-input
        v-model="search.alarmEventName"
        placeholder="请输入"
        clearable
      >
        <el-button slot="append" icon="el-icon-search" @click="doFilter"></el-button>
      </el-input>
    </div>
    <div class="box-table">
      <el-table :data="listData" height="100%" style="width: 100%" :header-cell-style="{background:'#F5F7F9',color:'#909399'}">
        <template slot="empty">
          <p>{{dataText}}</p>
        </template>
        <el-table-column label="序号" width="100">
          <template slot-scope="scope">
            <span>{{(currentPage-1)*pageSize + scope.$index+1}}</span>
          </template>
        </el-table-column>
        <el-table-column label="设备厂家">
          <template slot-scope="scope">
            <span class="color5" >{{scope.row.equipVender}}</span>
          </template> 
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalItems"
    ></el-pagination>
  </div>
</template>

<script>
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
export default {
  data(){
    return{
      search:{
        alarmEventName:'',
        camId:'',
      },
      groupId:'',
      // camId:'',
      id:'',
      //列表
      listData:[],
      dataText:'数据加载中...',
      //分页
      currentPage:1,
      pageSize:10,
      totalItems:0,

    }
  },
  mounted(){
    this.groupId = util.session.get('groupId')
    var params = this.$route.params
    this.search.camId = params.id
    this.getData()
  },
  methods:{
    //查询
    doFilter(){
      this.currentPage = 1
      this.getData()
    },
    //分页
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    // 监控当前页码
    currentChangePage() {
      this.getData()
    },
    //获取数据
    getData(){
      this.search.projectId = this.groupId
      this.search.pageSize = this.pageSize
      this.search.pageNum = this.currentPage
      myHttp.getEquipCameraWaringPhoto(this.search).then(resp=>{
        if(resp.data.code=='200'){
          var list = resp.data.data.pageInfo.list||[]
          this.listData = list
          this.totalItems = resp.data.data.pageInfo.total
          if(list.length==0){
            this.dataText = '暂无数据'
          }
        }else{
          this.dataText = '暂无数据'
        }
      })
    },
    //返回
    goBack(){
      this.$router.go(-1)
    },
  }
}
</script>

<style scoped>
  .hua-box{
    width: 100%;
    height: 100%;
    position: relative;
    background: #fff;
  }
  .box-head{
    width: 100%;
    height: 6vh;
    position: relative;
    display: flex;
    align-content: center;
    align-items: center;
    padding: 0 1vw;
  }
  .box-table{
    width: 100%;
    height: calc( 100% - 12vh );
    position: relative;
  }
</style>